import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaggageItemComponent } from './baggage-item.component';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [BaggageItemComponent],
  imports: [CommonModule, StaticMsgModule, AmountFormatModule],
  exports: [BaggageItemComponent],
})
export class BaggageItemModule {}
